import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AsapService, Global } from 'asap-crud';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-editor-custom-component-sidebar-config',
  templateUrl: 'sidebar-config.component.html',
  providers: [ AsapService ]
})
export class SidebarConfigComponent implements OnInit, OnChanges {

  @Input() item: any;
  @Input() components: any[];
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  colorToAdd: string;

  public monitoring = {
    categories: null
  }

  constructor(
    public global: Global,
    public service: AsapService
  ) {
  
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item && this.item) {
      if (!this.item.sidebarMonitoringHiddenCategories) {
        this.item.sidebarMonitoringHiddenCategories = [];
      }
      if (!this.item.sidebarMonitoringCategoryLabel) {
        this.item.sidebarMonitoringCategoryLabel = {};
      }
      if (!this.item.sidebarSelectedItems) {
        this.item.sidebarSelectedItems = [];
      }
    }
  }

  getComponentTitle(c: any): string {
    if (!c) return 'Item';
    if (c.title && typeof c.title === 'object' && c.title.text) {
      return c.title.text;
    }
    if (typeof c.title === 'string' && c.title) {
      return c.title;
    }
    if (c.titleText) {
      return c.titleText;
    }
    if (c.label) {
      return c.label;
    }
    if (c.type) {
      return c.type;
    }
    return 'Item';
  }

  getComponentIcon(c: any): string {
    if (typeof c === 'string') {
      if (c === 'Página inicial') return 'fa fa-home';
      if (c === 'Minha página') return 'fa fa-user';
      return 'fa fa-bookmark';
    }
    
    if (!c) return 'fa fa-clipboard';
    
    if (c.icon) {
      if (c.icon.startsWith('bi-') || c.icon.startsWith('bi ')) {
        return 'bi ' + c.icon;
      }
      if (c.icon.startsWith('fa-') || c.icon.startsWith('fa ')) {
        return c.icon;
      }
    }

    const type = c.type || '';

    const typeIcons: { [key: string]: string } = {
      'home': 'fa fa-home',
      'my_page': 'fa fa-user',
      'cursos-sessao': 'fa fa-graduation-cap',
      'aulas-rapidas-sessao': 'fa fa-book',
      'journey': 'fa fa-compass',
      'mini': 'fa fa-comments-o',
      'videos': 'fa fa-play-circle',
      'videos-sessao': 'fa fa-play-circle',
      'artigos': 'fa fa-file-text-o',
      'free': 'fa fa-laptop',
      'eventos': 'fa fa-calendar',
      'evento-sessao': 'fa fa-calendar-check-o',
      'news-section': 'fa fa-newspaper-o',
      'feed': 'fa fa-rss',
      'forum': 'fa fa-comments',
      'forum-theme': 'fa fa-comments',
      'forum-theme-sidebar': 'fa fa-comments',
      'users': 'fa fa-users',
      'usuarios-sidebar': 'fa fa-user-plus',
      'jobs': 'fa fa-briefcase',
      'vacancies': 'fa fa-id-card-o',
      'benefits': 'fa fa-gift',
      'conquistas': 'fa fa-trophy',
      'pontos': 'fa fa-star',
      'credits': 'fa fa-credit-card',
      'shortcuts': 'fa fa-th-list',
      'menu': 'fa fa-bars',
      'tecnico': 'fa fa-file-pdf-o',
      'main-tecnico': 'fa fa-folder-open',
      'assessment': 'fa fa-check-square-o',
      'slides': 'fa fa-sliders',
      'in_progress': 'fa fa-hourglass-half',
      'influenciadores': 'fa fa-star-o',
      'banner': 'fa fa-picture-o',
      'banner-link': 'fa fa-external-link',
      'studio': 'fa fa-video-camera',
      'gallery': 'fa fa-picture-o',
      'html': 'fa fa-code',
      'multicontas': 'fa fa-cubes'
    };

    return typeIcons[type] || 'fa fa-clipboard';
  }

  getItemObject(itemOrTitle: any, typeIfNew: string = ''): { title: string, type: string, icon: string, id?: string } {
    if (typeof itemOrTitle === 'string') {
      let type = typeIfNew;
      if (itemOrTitle === 'Página inicial') type = 'home';
      if (itemOrTitle === 'Minha página') type = 'my_page';
      const icon = this.getComponentIcon(itemOrTitle);
      return { title: itemOrTitle, type: type, icon: icon };
    }
    if (typeof itemOrTitle === 'object' && itemOrTitle !== null) {
      const title = this.getComponentTitle(itemOrTitle);
      const type = itemOrTitle.type || typeIfNew || 'component';
      const icon = this.getComponentIcon(itemOrTitle);
      const id = itemOrTitle.id || undefined;
      return { title, type, icon, id };
    }
    return { title: String(itemOrTitle), type: typeIfNew || 'component', icon: 'fa fa-bookmark' };
  }

  isItemSelected(itemObj: any): boolean {
    if (!this.item || !this.item.sidebarSelectedItems || !Array.isArray(this.item.sidebarSelectedItems)) {
      return false;
    }
    const targetTitle = typeof itemObj === 'string' ? itemObj : this.getComponentTitle(itemObj);
    return this.item.sidebarSelectedItems.some((s: any) => {
      if (typeof s === 'string') return s === targetTitle;
      return s && (s.title === targetTitle || (s.id && itemObj.id && s.id === itemObj.id));
    });
  }

  toggleItem(itemObj: any, defaultType: string = ''): void {
    if (!this.item.sidebarSelectedItems || !Array.isArray(this.item.sidebarSelectedItems)) {
      this.item.sidebarSelectedItems = [];
    }
    const targetTitle = typeof itemObj === 'string' ? itemObj : this.getComponentTitle(itemObj);
    const existingIndex = this.item.sidebarSelectedItems.findIndex((s: any) => {
      if (typeof s === 'string') return s === targetTitle;
      return s && (s.title === targetTitle || (s.id && itemObj.id && s.id === itemObj.id));
    });

    if (existingIndex >= 0) {
      this.item.sidebarSelectedItems.splice(existingIndex, 1);
    } else {
      const newObject = this.getItemObject(itemObj, defaultType);
      this.item.sidebarSelectedItems.push(newObject);
    }
  }

  ngOnInit(): void {
    this.loadCategories();
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

  getPhotoWithTarget(target: any, $event: any): void {
    this.item[target] = $event.path;
  }

  setAlign(element: any, align: string): void {
    element.align = align;
  }

  addColorToPallet() {
    if (this.colorToAdd === '') {
      return;
    }

    if (!this.item.myColors) {
      this.item.myColors = [];
    }
    this.item.myColors.push(this.colorToAdd);
    this.colorToAdd = '';
  }

  removeColor(index: number) {
    this.item.myColors.splice(index, 1);
  }

  loadCategories() {
    const categories = [];
    this.service.basePath = 'api/v2/admin';

    this.service.entityName = `monitoring/category/client/0`;
    categories.push(this.service.getResources());
    this.service.entityName = `monitoring/category/client/1`;
    categories.push(this.service.getResources());

    forkJoin(categories).subscribe((responses) => {
      this.monitoring.categories = [
        ... responses[0].data,
        ... responses[1].data
      ];
    });
  }

  hideMonitoringCategory(cat) {
    const idx = this.item.sidebarMonitoringHiddenCategories.indexOf(cat.id)
    if (idx < 0) {
      this.item.sidebarMonitoringHiddenCategories.push(cat.id);
    }
    else {
      this.item.sidebarMonitoringHiddenCategories.splice(idx,1);
    }
  }

}
